// src/providers/smartCount.ts
/**
 * The plural form follows `smart_count`. Most messages state a quantity as
 * `count` (often already formatted, «3.088»), so when a caller passes `count`
 * without `smart_count` the plural is chosen from it: «1 reserva» /
 * «7393 reservas» instead of «1 reservas». A message without plural forms is
 * unaffected.
 *
 * An unknown quantity (null / undefined) must never leave the raw template
 * («%{count} adulto |||| %{count} adultos») on screen: it reads «— adultos».
 */
export const withSmartCount = (options?: any): any => {
  // A default string («translate(key, 'Loading...')») is not an options object.
  if (!options || typeof options !== 'object' || options.smart_count != null) return options;
  if ('count' in options && options.count == null) return { ...options, count: '—', smart_count: 2 };
  if (options.count == null) return 'smart_count' in options ? { ...options, smart_count: 2 } : options;
  const { count } = options;
  if (typeof count === 'number') return { ...options, smart_count: count };
  const text = String(count).trim();
  // «7393», «3.088», «12 345»: an integer, with or without thousands separators.
  const integer = /^-?\d{1,3}([.\s\u00a0]?\d{3})*$/.test(text) ? Number(text.replace(/[^\d-]/g, '')) : null;
  // Anything else («1,5») is not exactly one: plural.
  return { ...options, smart_count: integer ?? 2 };
};
